import { getTrackingService } from './TrackingServiceInstance';

export const updateVisitorProperties = (
    obj: { [key: string]: unknown },
    options?: { suppressConversion?: boolean },
) => getTrackingService().getSession().updateVisitorProperties(obj, options);

/**
 * Applied after a form submit whose conversion was held back until phone/email verification
 * succeeded (FUN-3876).
 */
export const triggerDeferredConversion = () => {
    getTrackingService().getSession().triggerDeferredConversion();
};

export const getVisitorProperties = () => getTrackingService().getSession().getVisitorProperties();
